<template>
  <div>
    <h1 class="title has-text-centered">Food for Thought</h1>

    <p class="notification is-info has-text-centered">
      <span class="has-text-weight-semibold">NB:</span> Think about it!!
    </p>

    <div class="columns is-multiline">
      <div v-for="post in posts" :key="post.id" class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="card post-preview" @click="openModal(post)">
          <div class="card-content">
            <h2 class="title is-4">{{ post.title }}</h2>
            <p class="subtitle is-6">{{ post.excerpt }}</p>
          </div>
        </div>
      </div>
    </div>
<br/>
<br/>
    <!-- Modal for Posts -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPost">
          <h2>{{ currentPost.title }}</h2>
          <p>{{ currentPost.fullText }}</p>
        </div>
        <button @click="prevPost" class="nav-button prev">&lt;</button>
        <button @click="nextPost" class="nav-button next">&gt;</button>
      </div>
    </div>
  </div>
</template>
<script>

import Hammer from 'hammerjs';
export default {
  name: 'FoodForThoughtPage',
  data() {
    return {
    posts : [
  { 
    id: 1, 
    title: 'The Holy Trinity Numbers', 
    excerpt: '3, 6, and 9 are special in mathematics...', 
    fullText: '3, 6, and 9 create a harmonious loop of their own. For instance, 3 added to itself gives 6, and 6 doubled returns to 3 (since 6+6=12, and 1+2=3). In contrast, 9 is exceptional; it remains unchanged when added to itself (9+9=18, and 1+8=9). 9 is actually the only independent number a "GOD" number - these three numbers are also known as the "Holy Trinity Numbers". While other numbers such as 1, 2, 4, 5, 7, and 8 cycle through predictable patterns—where 1+1=2, 2+2=4, 4+4=8, 5+5=10 and 1+0 gets us back to 1, 7+7=14 (4+1=5) (8+8=16 and 6+1=7)—this pattern happens infinitely without 3, 6, and 9 ever appearing.' 
  },
  { 
    id: 2, 
    title: 'The Power of Positive Thinking', 
    excerpt: 'Thought-provoking...', 
    fullText: 'The power of positive thinking is not just a motivational phrase but a psychological strategy that helps people overcome challenges and achieve their goals. Positive thinking involves focusing on the good in any situation, which can lead to improved health, increased success, and a more fulfilling life. By transforming your mindset, you can influence your actions and outcomes in profound ways.' 
  },
  { 
    id: 3, 
    title: 'The Intriguing World of Quantum Computing', 
    excerpt: 'A leap into future technology...', 
    fullText: 'Quantum computing represents a significant leap in computational capability, utilizing the principles of quantum mechanics to process information. Unlike classical computers, which use bits as the smallest unit of data, quantum computers use qubits, which can represent and process multiple states simultaneously. This capability allows quantum computers to solve complex problems much faster than their classical counterparts, potentially revolutionizing fields such as cryptography, drug discovery, and complex system modeling.' 
  },
  { 
    id: 4, 
    title: 'The Friendship Equation', 
    excerpt: 'Friendship as a mathematical model...', 
    fullText: 'Friendship can be seen as a mathematical model where each connection contributes to a larger network of relationships. The strength of friendship can be represented by the interactions and shared experiences between individuals. This model helps us understand how friendships form, evolve, and impact our lives, emphasizing the importance of maintaining and nurturing these connections over time.' 
  },
  { 
    id: 5, 
    title: 'The Impact of Artificial Intelligence on Modern Society', 
    excerpt: 'AI is reshaping our world...', 
    fullText: 'Artificial Intelligence (AI) is transforming various aspects of modern society, from how we work to how we interact with technology. AI systems can analyze large datasets, automate tasks, and make predictions with high accuracy, leading to advancements in fields such as healthcare, finance, and transportation. While AI offers significant benefits, it also raises ethical considerations and challenges related to privacy, employment, and decision-making. Understanding and managing these impacts is crucial as AI continues to evolve.' 
  },
  { 
    id: 6, 
    title: 'The Evolution of Friendship', 
    excerpt: 'Friendship through the ages...', 
    fullText: 'Friendship has evolved significantly through history, adapting to changes in communication and societal norms. From ancient times when friendships were forged through face-to-face interactions and shared experiences, to the digital age where social media and online platforms have redefined how we connect, the essence of friendship remains rooted in mutual respect, trust, and support. This evolution highlights the adaptability of human relationships in response to technological and social changes.' 
  },
  { 
    id: 7, 
    title: 'The Philosophy of Time Travel', 
    excerpt: 'Exploring time travel concepts...', 
    fullText: 'Time travel, a concept popularized by science fiction, raises intriguing philosophical questions about the nature of time and causality. If time travel were possible, it could potentially allow us to revisit past events or explore future scenarios, challenging our understanding of linear time and cause-and-effect relationships. Philosophers and scientists debate the implications of time travel on our perception of reality and its potential impact on historical events and personal decisions.' 
  },
  { 
    id: 8, 
    title: 'The Role of Technology in Shaping Human Behavior', 
    excerpt: 'Technology\'s influence on us...', 
    fullText: 'Technology plays a significant role in shaping human behavior by altering how we communicate, work, and entertain ourselves. Innovations such as smartphones, social media, and artificial intelligence have changed our daily lives, influencing our interactions and decision-making processes. While technology offers convenience and opportunities, it also presents challenges related to privacy, dependency, and the impact on mental health. Understanding these effects helps us navigate the complexities of modern life.' 
  },
  { 
    id: 9, 
    title: 'The Holy Trinity of Numbers', 
    excerpt: 'An exploration of 3, 6, and 9...', 
    fullText: '3, 6, and 9 are often considered the holy trinity of numbers due to their unique properties and harmonious relationships. For example, adding 3 to itself results in 6, and doubling 6 returns to 3 (since 6+6=12, and 1+2=3). The number 9 is exceptional; when added to itself (9+9=18), it remains unchanged after summing its digits (1+8=9). These numbers create a loop of their own, contrasting with other numbers that cycle through predictable patterns. The trio of 3, 6, and 9 embodies a profound numerical harmony and is sometimes regarded as a representation of divine order.' 
  },
  { 
    id: 10, 
    title: 'The Intersection of Art and Technology', 
    excerpt: 'Merging creativity and innovation...', 
    fullText: 'The intersection of art and technology represents a dynamic fusion of creativity and innovation. Digital tools and technologies have expanded the possibilities for artistic expression, enabling artists to create immersive experiences and interactive installations. This collaboration between art and technology not only enhances the aesthetic experience but also explores new ways of engaging with audiences and pushing the boundaries of traditional art forms.' 
  },
  { 
    id: 11, 
    title: 'The Psychology of Decision Making', 
    excerpt: 'Understanding choices...', 
    fullText: 'The psychology of decision-making explores how individuals make choices and the cognitive processes involved. Factors such as emotions, biases, and cognitive shortcuts influence decision-making, often leading to irrational or suboptimal outcomes. Understanding these psychological mechanisms can help individuals make better decisions by recognizing and mitigating biases, improving judgment, and enhancing problem-solving skills.' 
  },
  { 
    id: 12, 
    title: 'The Influence of Social Media on Society', 
    excerpt: 'Social media\'s impact...', 
    fullText: 'Social media has a profound influence on society, shaping communication, information dissemination, and social interactions. Platforms like Facebook, Twitter, and Instagram have transformed how we connect with others, share information, and express ourselves. While social media offers opportunities for connection and engagement, it also presents challenges related to misinformation, privacy, and mental health. Navigating the complexities of social media is essential for maintaining a balanced and informed perspective.' 
  },
  { 
    id: 13, 
    title: 'The Art of Communication in a Digital Age', 
    excerpt: 'Communicating effectively online...', 
    fullText: 'The art of communication in a digital age involves mastering various online platforms and tools to convey messages effectively. Digital communication requires understanding the nuances of written and visual content, as well as the impact of tone, timing, and audience engagement. Effective communication in this context helps build relationships, share information, and achieve personal and professional goals in a rapidly evolving digital landscape.' 
  },
  { 
    id: 14, 
    title: 'The Ethics of Artificial Intelligence', 
    excerpt: 'Navigating AI\'s moral implications...', 
    fullText: 'The ethics of artificial intelligence involves examining the moral implications and responsibilities associated with developing and deploying AI systems. Issues such as bias, transparency, and accountability are critical in ensuring that AI technologies are used ethically and for the benefit of society. Addressing these ethical concerns helps build trust in AI systems and promotes responsible innovation in this rapidly advancing field.' 
  },
  { 
    id: 15, 
    title: 'The Philosophy of Happiness', 
    excerpt: 'Exploring what makes us happy...', 
    fullText: 'The philosophy of happiness delves into the nature of well-being and what constitutes a fulfilling life. Various philosophical perspectives offer insights into the sources of happiness, including the pursuit of pleasure, the cultivation of virtue, and the development of meaningful relationships. Understanding these perspectives can help individuals identify and pursue what brings them true contentment and satisfaction.' 
  },
  { 
    id: 16, 
    title: 'The Future of Virtual Reality', 
    excerpt: 'VR\'s potential...', 
    fullText: 'Virtual Reality (VR) represents a significant technological advancement with the potential to transform various industries. By creating immersive and interactive experiences, VR can enhance education, training, entertainment, and therapy. As VR technology continues to evolve, its applications and impact on society are expected to grow, offering new opportunities for exploration and innovation in diverse fields.' 
  },
  { 
    id: 17, 
    title: 'The Role of Friendship in Personal Growth', 
    excerpt: 'Friendship and self-improvement...', 
    fullText: 'Friendship plays a crucial role in personal growth by providing support, encouragement, and perspective. Friends can challenge us to grow, offer guidance during difficult times, and celebrate our successes. The dynamic nature of friendships contributes to our development, helping us become more self-aware, resilient, and empathetic individuals.' 
  },
  { 
    id: 18, 
    title: 'The Ethics of Digital Privacy', 
    excerpt: 'Protecting personal information...', 
    fullText: 'The ethics of digital privacy addresses the need to protect personal information in an increasingly connected world. With the rise of data collection and surveillance technologies, ensuring the privacy and security of personal data is essential. Ethical considerations include the responsible handling of data, transparency in data practices, and the protection of individuals\' rights and freedoms in the digital realm.' 
  },
  { 
    id: 19, 
    title: 'The Impact of Technology on Human Relationships', 
    excerpt: 'Tech and our connections...', 
    fullText: 'Technology has a profound impact on human relationships, shaping how we interact and connect with others. While digital tools facilitate communication and strengthen connections across distances, they can also lead to superficial interactions and decreased face-to-face engagement. Balancing technology use with meaningful personal interactions is key to maintaining healthy and fulfilling relationships.' 
  },
  { 
    id: 20, 
    title: 'The Significance of Emotional Intelligence', 
    excerpt: 'Understanding emotions...', 
    fullText: 'Emotional intelligence involves the ability to recognize, understand, and manage one\'s own emotions as well as those of others. This skill is crucial for effective communication, relationship-building, and overall well-being. Developing emotional intelligence enhances personal and professional interactions, leading to greater empathy, conflict resolution, and self-awareness.' 
  },
   { 
    id: 21, 
    title: 'This is my body', 
    excerpt: 'Abortion is a lie...', 
    fullText: 'Satan, in his rebellion, would overthrow God if he could, but he cannot. Instead, he seeks to harm what God cherishes most: His children. This relentless attack is most evident in the tragedy of abortion, which serves as a perverse sacrament in the kingdom of darkness. At its core, abortion proclaims, "You must die so that I can live," a chilling inversion of Christ’s sacrificial love. Jesus, the Savior, entered our broken world through the sanctity of a human womb to bring redemption. In the ultimate act of love, He declared, "This is my body", offering Himself for humanity\'s salvation. This statement, spoken at the Last Supper, contrasts starkly with the misuse of the same phrase by proponents of abortion, who invoke "This is my body" as a defense of bodily autonomy to justify the destruction of life. Is it mere coincidence that the language of self-sacrifice in the Gospel is mirrored and twisted by the culture of death? Or is it a deliberate subversion of divine truth, aimed at turning love\'s greatest expression into a justification for its opposite?' },   
      
]
,
     isModalOpen: false,
      currentPost: null,
      currentIndex: 0
    };
  },
  methods: {
    openModal(post) {
      this.currentPost = post;
      this.currentIndex = this.posts.findIndex(p => p.id === post.id);
      this.isModalOpen = true;

      // Initialize Hammer.js
      this.$nextTick(() => {
        const element = this.$refs.modalContent;
        const hammer = new Hammer(element);

        hammer.on('swipeleft', this.nextPost);
        hammer.on('swiperight', this.prevPost);
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentPost = null;
    },
    nextPost() {
      if (this.currentIndex < this.posts.length - 1) {
        this.currentIndex += 1;
        this.currentPost = this.posts[this.currentIndex];
      }
    },
    prevPost() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.currentPost = this.posts[this.currentIndex];
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 20px;
}

.post {
  margin-bottom: 20px;
}

.post-preview {
  cursor: pointer;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-preview:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.post-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: black;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  animation: fadeIn 0.3s ease;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content p {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.nav-button {
  background: rgba(0, 123, 255, 0.5); /* Adjust the alpha value (0.5) for transparency */
  border: none;
  color: white;
  padding: 10px;
  border-radius: 1px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nav-button.prev {
  left: 0px;
}

.nav-button.next {
  right: 0px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
